import React from 'react';
import classNames from 'classnames';
import { ErrorMessage, useField } from 'formik';

import styles from './FormikUrlInput.module.scss';

export const FormikUrlInput = ({
  name,
  label,
  shouldDisplayLabel = true,
  isRequired,
  isOptional,
  protocol = 'https://',
  placeholder = 'www.',
  isLinkedIn = false,
  ...props
}) => {
  const [field, meta, { setValue }] = useField(name);

  const handleLinkedinLinkChange = (value) => {
    let profileName = value;

    profileName = profileName.replace(/^(https?:\/\/)?(www\.)?/, '');

    if (profileName.includes('linkedin.com/in/')) {
      [, profileName] = profileName.split('linkedin.com/in/');
    } else if (profileName.includes('linkedin.com/company/')) {
      [, profileName] = profileName.split('linkedin.com/company/');
    } else if (profileName.startsWith('in/')) {
      profileName = profileName.substring(3);
    } else if (profileName.startsWith('company/')) {
      profileName = profileName.substring(8);
    }

    [profileName] = profileName.split('/');
    [profileName] = profileName.split('?');

    profileName = profileName.replace(/^\/*/, '').replace(/\/*$/, '');

    setValue(`www.linkedin.com/in/${profileName}`);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const cleanValue = inputValue.replace(/^https?:\/\//, '');

    if (isLinkedIn) {
      const linkedinLink = cleanValue.replace('www.linkedin.com/in/', '');
      handleLinkedinLinkChange(linkedinLink);
    } else {
      setValue(cleanValue);
    }
  };

  const handleInputKeyDown = (e) => {
    if (isLinkedIn && e.key === 'Backspace' && field.value === 'www.linkedin.com/in/') {
      e.preventDefault();
    }
  };

  return (
    <div className={styles.container}>
      {shouldDisplayLabel && (
        <label htmlFor={name} className={styles.label}>
          {label} {isRequired && <span className={styles.required}>*</span>}{' '}
          {isOptional && <span className={styles.optional}>(Optional)</span>}
        </label>
      )}
      <div className={classNames(styles.urlInputField)}>
        <span
          className={classNames(styles.protocol, {
            [styles.error]: meta.touched && meta.error,
            'border-r-0': meta.touched && meta.error,
          })}
        >
          {protocol}
        </span>
        <input
          {...field}
          {...props}
          type="text"
          name={name}
          placeholder={placeholder}
          value={field.value || ''}
          onChange={handleInputChange}
          onKeyDown={handleInputKeyDown}
          className={classNames(styles.input, { [styles.error]: meta.touched && meta.error })}
        />
      </div>
      <ErrorMessage name={name} component="div" className={styles.errorMessage} />
    </div>
  );
};
